import { useQuery } from '@tanstack/react-query';
import { getStorageUsage } from '../api/filesApi';

export const storageUsageKeys = {
  all: ['storage-usage'] as const,
};

export function useStorageUsage() {
  return useQuery({
    queryKey: storageUsageKeys.all,
    queryFn: getStorageUsage,
  });
}
